import React from 'react';
import {
  Filter as FilterAdmin,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

import {
  PeriodoInput,
  PrecoInput,
  IntegerInput,
  NfeInput,
} from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils/constants';
import { choicesPagamento } from './choices';

const Filter = (props) => (
  <FilterAdmin {...props}>
    {/* <IntegerInput source="id" label="Número da compra" prefixo="#" /> */}
    <ReferenceInput
      fullWidth
      label="Fornecedor"
      source="fornecedor_id"
      reference="fornecedores"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <SelectInput
      source="status"
      choices={choicesPagamento}
      allowEmpty={false}
    />
    <PeriodoInput
      source="periodo"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <PrecoInput
      source="valor"
      label="Valor da compra"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorParcela"
      label="Valor Parcela"
      fixedDecimalScale={false}
    />
    <NfeInput source="numero_nota_fiscal" label="Nfe" />
    <IntegerInput source="numero" label="Número da compra" prefixo="#" />
  </FilterAdmin>
);

export default Filter;
